module.exports = __webpack_public_path__ + "img/line-chart-spline-light-01.55a5a2b7.jpg";